// test.mp4 => test-low_resolution.mp4
export const convertFileNameToLowResolution = (path: string): string => {
  return path.split('.').slice(0, -1).join('.') + '-low_resolution.mp4';
};

// test.mp4 => test.jpg
export const convertFileNameToOgp = (path: string): string => {
  return path.match('.+/(.+?)([?#;].*)?$')[1].split('.')[0] + '.jpg';
};
